<template>
    <div>

        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="ICCID：">
                <el-input  v-model.trim="searchForm.iccid" @keyup.enter.native="getStopRecordListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="停机状态："> 
                <el-select v-model="searchForm.stateName" clearable>
                    <el-option label="停机成功" value="成功"></el-option>
                    <el-option label="停机失败" value="失败"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getStopRecordListHandler">搜索查询</el-button>
                <el-button type="success" plain @click="getStopRecordListHandler">刷新</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" plain @click="confirmExportDialogVisible = true">导出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
            <el-table-column prop="intoNo" label="接入号" align="center"></el-table-column>
            <!-- <el-table-column prop="supplierName" label="供应商"></el-table-column>
            <el-table-column label="总流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.totalRateFlow) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.totalUsedFlow) }}
                </template>
            </el-table-column> -->
            <el-table-column prop="createTime" label="停机时间" align="center"></el-table-column>
            <el-table-column prop="failReason" label="操作结果" align="center"></el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportStopRecordListHandler">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getStopRecordList,exportPollingStopInfo} from '@/api/csm.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                stateName:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            confirmExportDialogVisible:false//导出确认框
        }
    },
    methods: {
        getStopRecordListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getStopRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getStopRecordListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getStopRecordListHandler();
        },
        exportStopRecordListHandler(){
            let _that = this;

            exportPollingStopInfo(_that.searchForm).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));         
        }    
    },
    created(){
        this.getStopRecordListHandler();
    }
}
</script>